/* eslint-disable jsx-a11y/alt-text */
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";

import { Globals } from "../utils";
import Logo from '../assets/img/logo.png';
import MenuIcon from '../assets/icons/menu.png';
import ReportsIcon from '../assets/icons/reports.png';
import LogoutIcon from '../assets/icons/logout.png';
import { Link } from "react-router-dom";

interface Props {
  history: any
  leftSlot?: any
  hideContentBreadcumbs?: boolean
  rightSlot?: any
  children?: Element | any
}

interface SubmenuItem {
  path: string
  name: string
}

interface MenuItem {
  icon: any
  name: string
  path?: string
  modules?: SubmenuItem[]
}

const MODULES = {
  REPORTS: 0,
}

const menu: MenuItem[] = [
  {
    icon: ReportsIcon,
    name: 'Reportes',
    modules: [
      {
        path: '/',
        name: 'Reporte de Usuarios',
      },
      {
        path: '/payment-report',
        name: 'Reporte de Pagos',
      },
    ],
  },
];

const Menu = (props: Props) => {
  const sidebarClosedRef = useRef<boolean>(false);
  const dispatch = useDispatch();

  const logout = () => {
    Globals.confirm('¿Desea cerrar sesión?',() => {
      dispatch({
        type: 'SET_USER',
        payload: null
      });
      props.history.replace('/login');
      Globals.quitLoading();
    });
  };

  const handleToggle = (hasSubmenu = false) => {
    if (!sidebarClosedRef.current || (sidebarClosedRef.current && !hasSubmenu)) return;
    toggleSidebar()
  };

  const toggleSidebar = () => {
    sidebarClosedRef.current = !sidebarClosedRef.current;
    const sidebar = document.getElementById('sidebar');

    if (sidebarClosedRef.current) {
      const submenus = document.querySelectorAll('ul.navbar-collapse');
      for (let index = 0; index < submenus.length; index++) {
        submenus[index].classList.remove('show');
      }

      sidebar?.classList?.add('closed');

    } else {
      sidebar?.classList?.remove('closed');
    }
  };

  const getBreadcumbs = () => {
    return '';
  };

  const getTitle = () => {
    let route;
    menu.forEach(r => {
      let found: any = r.path === props.history.location.pathname;
      if (found) route = r.name;

      found = r.modules?.find(x => String(x.path) === props.history.location.pathname)
      if (found) route = found.name;
    });
    return route || '';
  }

  const isActiveModule = (routes?: SubmenuItem[]) => {
    return routes?.find(x => x.path === props.history.location.pathname);
  };

  const isActiveRoute = (item?: SubmenuItem) => {
    return props.history.location.pathname === item?.path ? 'active' : '';
  };

  return (
    <div id="layout">
      <header>
        <div className="logo">
          <img src={Logo} style={{ width: "90%", padding: "0.5rem 2rem" }} alt="SYSGE24"/>

          <button
            className="toggle-menu"
            onClick={() => toggleSidebar()}
            title="Ocultar Menú"
          >
            <img src={MenuIcon} alt="Ocultar Menú" />
          </button>
        </div>
        <div className="content-header">
          <div className="group">
            {!!props.leftSlot && props.leftSlot}
            {!props?.hideContentBreadcumbs && (
              <div className="content-breadcumbs">
                <div className="breadcumbs">{getBreadcumbs()}</div>
                <div className="title">{getTitle()}</div>
              </div>
            )}
          </div>
          {!!props.rightSlot && props.rightSlot}
          <div className="logout">
            <div onClick={logout}>
              <img src={LogoutIcon} alt="Cerrar sesión" />
              <span>Cerrar Sesión</span>
            </div>
          </div>
        </div>
      </header>

      <div className="container-app">
        <div id="left">
          <div id="sidebar">
            <div className="user">
              <div>
                {/* <button
                  className="toggle-menu"
                  onClick={() => toggleSidebar()}
                  title="Ocultar Menú"
                >
                  <img src={MenuIcon} alt="Ocultar Menú" />
                </button> */}

                {/* <div className="info">
                  <p>{ this.props.user?.admin?.name }</p>
                  <p>{ this.props.user.name }</p>
                </div> */}
              </div>
              {/* <div className="divider" /> */}
            </div>
            <div className="container-menu">
              <div className="menu">
                <Scrollbars
                  autoHide={true}
                  renderTrackHorizontal={({ style, ...props }: any) => (
                    <div
                      {...props}
                      style={{ ...style, backgroundColor: " blue " }}
                    />
                  )}
                >
                  <ul className="items">
                    <li className={'li-' + isActiveRoute(isActiveModule(menu[MODULES.REPORTS].modules))}>
                      <a
                        href="#menu-item-reports"
                        data-toggle="collapse"
                        aria-expanded={!!isActiveModule(menu[MODULES.REPORTS].modules)}
                        className={!!isActiveModule(menu[MODULES.REPORTS].modules)
                          ? 'dropdown-toggle'
                          : 'dropdown-toggle collapsed'
                        }
                      >
                        <button className="icon-button" title={menu[MODULES.REPORTS].name} onClick={() => handleToggle(true)}>
                          <img src={menu[MODULES.REPORTS].icon} alt={menu[MODULES.REPORTS].name} />
                        </button>
                        <span>{menu[MODULES.REPORTS].name}</span>
                      </a>
                      <ul id="menu-item-reports" className={`navbar-collapse collapse ${isActiveModule(menu[MODULES.REPORTS].modules) ? 'show' : ''}`}>
                        {menu[MODULES.REPORTS].modules?.map((item, key) => (
                          <CustomLink key={key} item={item} isActiveRoute={isActiveRoute} />
                        ))}
                      </ul>
                    </li>
                  </ul>
                </Scrollbars>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">{ props.children }</div>
      </div>
    </div>
  );
}

interface CustomLinkProps {
  item: any
  isActiveRoute: any
}

const CustomLink = ({ item, isActiveRoute }: CustomLinkProps) => (
  <li className={isActiveRoute(item)}>
    <Link className="nav-link" to={item.path}>
      {item.name}
    </Link>
  </li>
);

export default Menu;
